import { render } from "./RatingContent.vue?vue&type=template&id=1e401257"
import script from "./RatingContent.vue?vue&type=script&lang=js"
export * from "./RatingContent.vue?vue&type=script&lang=js"

import "./RatingContent.vue?vue&type=style&index=0&id=1e401257&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__